import React__default from "react";
const useFileUpload = ({ files }) => {
  const fileInputRef = React__default.useRef(null);
  const textBelowButtonRef = React__default.useRef(null);
  const fileHasError = Boolean(files?.find((file) => file.state === "error"));
  const isOneFile = files && files.length === 1;
  const fileErrorMessage = fileHasError && isOneFile ? files[0].errorMessage : void 0;
  return {
    fileInputRef,
    textBelowButtonRef,
    fileErrorMessage
  };
};
export {
  useFileUpload
};
//# sourceMappingURL=useFileUpload.js.map
